module.exports = "/packs/media/modules/shared/resources/thumbnail-product-placeholder-2c6777ff39a3660a4f0eae9416ae537b.png";